export default __webpack_public_path__ + "static/garden_design7-2ab7d5f00aad5a63a96faf5ff8dc518b.webp";